import { Banner, Link, Primary13SemiBold } from '@sequencehq/core-components'
import { QuoteContentBanner } from 'modules/Cube/view/layouts/quote/QuoteContentColumn/QuoteContentBanner'
import { useAmendmentOutForSignatureBanner } from './useAmendmentOutForSignatureBanner'

export const AmendmentOutForSignatureBanner = () => {
  const { isVisible, outForSignatureQuote } =
    useAmendmentOutForSignatureBanner()

  if (!isVisible) {
    return null
  }

  return (
    <QuoteContentBanner>
      <Banner
        variant="warning"
        data-testid="quote.amendmentOutForSignatureBanner"
      >
        <Link
          {...Primary13SemiBold}
          color="inherit"
          textDecoration="underline"
          to={`/quotes/${outForSignatureQuote.id}`}
          data-testid="quote.amendmentOutForSignatureBanner.link"
        >
          {outForSignatureQuote.label}
        </Link>{' '}
        is already out for signature or signed for this billing schedule. This
        quote can't be sent for signature or marked as signed until that one is
        executed, archived or expires.
      </Banner>
    </QuoteContentBanner>
  )
}
